import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-visibility"
export default class extends Controller {
  static targets = ["input", "icon"]

  toggle() {
    if (this.inputTarget.type === "password") {
      this.inputTarget.type = "text"
      this.iconTarget.classList.remove("bi-eye")
      this.iconTarget.classList.add("bi-eye-slash")
    } else {
      this.inputTarget.type = "password"
      this.iconTarget.classList.remove("bi-eye-slash")
      this.iconTarget.classList.add("bi-eye")
    }
  }
}
